import PropTypes from 'prop-types';
import { createStructuredSelector } from 'reselect';
import {
  formFieldPropTypes,
  formFieldDefaultProp
} from '../../propTypes/formFieldPropTypes';

import {
  visibleFormNotCorrectExamSelector,
  loadingNotCorrectExamSelector,
  formNotCorrectExamSelector
} from '../../store/notCorrectExam/selectors';

export const notCorrectExamStructuredSelector = createStructuredSelector({
  loading: loadingNotCorrectExamSelector,
  visibleForm: visibleFormNotCorrectExamSelector,
  form: formNotCorrectExamSelector
});

export const notCorrectExamStructuredSelectorPropTypes = {
  loading: PropTypes.bool,
  visibleForm: PropTypes.bool,
  form: PropTypes.shape({
    email: formFieldPropTypes,
    phone: formFieldPropTypes,
    comment: formFieldPropTypes
  })
};

export const notCorrectExamStructuredSelectorDefaultProp = {
  loading: false,
  visibleForm: false,
  form: {
    email: formFieldDefaultProp,
    phone: formFieldDefaultProp,
    comment: formFieldDefaultProp
  }
};
